module.exports = __webpack_public_path__ + "img/ondulacao.69cd9491.svg";